module.exports = __webpack_public_path__ + "img/tc1.b2644b40.png";